// extracted by mini-css-extract-plugin
module.exports = {"TopActions":"TopActions_TopActions__C0gw3","RightSide":"TopActions_RightSide__aPfqo","FavBtn":"TopActions_FavBtn__EGoWX"};